import React, { useMemo } from 'react';
import { ProductMetaInfo } from '../../../integrations/relewise/types/mapped';
import { CollapsibleItemData } from '../../../shared/components/collapsible-group/collapsible-group';
import { ICusNewBuyboxResources } from '../cus-new-buybox.props.autogenerated';

interface UseProductMetaInfoDataArgs {
    productMetaInfo: ProductMetaInfo | undefined;
    resources: ICusNewBuyboxResources;
    productItemId: string | undefined;
}
export const useProductMetaInfoData = ({ productMetaInfo, resources, productItemId }: UseProductMetaInfoDataArgs) => {
    const productMetaInfoCollapsiblesData = useMemo<CollapsibleItemData[]>(() => {
        const metaInfo = productMetaInfo;
        if (!metaInfo) {
            return [];
        }

        const careInstructions = Object.values(metaInfo.careInstructions).filter(Boolean);
        return [
            {
                id: 'description',
                title: resources.productDescriptionHeading,
                content: metaInfo.description,
                appendedContent: (
                    <p>
                        {resources.productIdText}: {productItemId}
                    </p>
                ),
                renderAsHtml: true
            },
            {
                id: 'care-instructions',
                title: resources.productCareHeading,
                content: careInstructions.map((instruction, index) => <p key={`${instruction}-${index}`}>{instruction}</p>)
            },
            {
                id: 'composition',
                title: resources.productCompositionHeading,
                content: metaInfo.composition
            }
        ].filter(section => Boolean(section.content));
    }, [productMetaInfo, resources, productItemId]);

    return productMetaInfoCollapsiblesData;
};
